import {
  successColor,
  tooltip,
  cardTitle,
  grayColor,
  blackColor,
} from "../../../../StyledComponents/material-dashboard-pro-react.js";

import AlterImg from "../../../../assets/images/AlterImg.jpeg";

const hoverCardStyle = {
  cardHover: {
    "&:hover": {
      "& $cardHeaderHover": {
        transform: "translate3d(0, -50px, 0)",
      },
    },
  },
  cardHeaderHover: {
    transition: "all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
  },
  cardHoverUnder: {
    position: "absolute",
    zIndex: "1",
    top: "-50px",
    width: "calc(100% - 30px)",
    left: "17px",
    right: "17px",
    textAlign: "center",
  },
};

const dashboardStyle = {
  ...hoverCardStyle,
  tooltip,
  tabCon: {
    "@media (max-width: 1580px)": {
      width: "max-content !important",
      textAlign: "center",
      // backgroundColor:'pink !important'
    },
  },
  cardTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  cardProductTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    textAlign: "center",
  },
  inputFieldStyle: {
    backgroundColor: "#EFF2F4",
    color: "black",
  },
  option: {
    color: "black !important",
  },
  cardCategory: {
    color: grayColor[0],
    fontSize: "14px",
    fontFamily: "'DM Sans','sans-serif'",
    paddingTop: "10px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0",
  },
  heading: {
    color: blackColor,
    fontSize: "17px",
    fontFamily: "'DM Sans','sans-serif'",
    paddingTop: "10px",
    marginBottom: "10px",
    marginTop: "0",
    margin: "0",
  },
  cardProductDesciprion: {
    textAlign: "center",
    color: grayColor[0],
  },
  stats: {
    color: grayColor[0],
    fontSize: "12px",
    lineHeight: "22px",
    display: "inline-flex",
    "& svg": {
      position: "relative",
      top: "4px",
      width: "16px",
      height: "16px",
      marginRight: "3px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      fontSize: "16px",
      marginRight: "3px",
    },
  },
  productStats: {
    paddingTop: "7px",
    paddingBottom: "7px",
    margin: "0",
  },
  successText: {
    color: successColor[0],
  },
  upArrowCardCategory: {
    width: 14,
    height: 14,
  },
  underChartIcons: {
    width: "17px",
    height: "17px",
  },
  price: {
    color: "inherit",
    "& h4": {
      marginBottom: "0px",
      marginTop: "0px",
    },
  },
  asterisk: {
    color: "red",
  },
  text: {
    color: "black",
  },
  inputField: {
    padding: "8.5px",
    width: "100%",
    display: "block",
    minWidth: 0,

    fontFamily: "Arial",
    fontSize: 16,
    borderRadius: 4,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#B4B4B4",
    "&:hover": {
      borderColor: "#000",
      cursor: "text",
    },
  },

  helperText: {
    marginLeft: 0,
  },

  AltImage: {
    fontSize: "0" /* hide the alt text */,
    backgroundImage: `url(${AlterImg})`,
    backgroundSize: "cover" /* scale the image to fit within the element */,
    width: "760px",
    height: "701px",
  },
  hs_form_required: { color: "black" },

  // style for check box on new invoice page
  checkboxContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "left",
    padding: "5px",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "left",
    marginRight: "16px",
  },
  tableStyle: {
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },

  tabCon: {
    "@media (max-width: 1580px)": {
      width: "max-content !important",
      textAlign: "center",
      // backgroundColor:'pink !important'
    },
  },
  checkboxItemFirst: {
    marginLeft: 0,
  },
  "@media only screen and (max-width: 991px)": {
    checkboxContainer: {
      flexDirection: "row",
    },
    checkboxItem: {
      marginBottom: "8px",
      marginRight: 0,
    },
    checkboxItemFirst: {
      marginBottom: "8px",
    },
  },
  // style for card header
  card_Header__back_button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3rem",
    height: "3rem",
    fontSize: "1.5rem",
    color: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: "50%",
    transition: "background-color 0.2s ease-in-out",
  },
};

export { dashboardStyle };
